import { ListBulletIcon, Squares2X2Icon } from '@heroicons/react/24/outline';

/**
 * Phase 57 Plan 57-05 — PORTAL-05
 *
 * Two-segment view toggle for the portal requests surface.
 * Renders a Requests/Board switch; the parent (PortalRequestsPage) holds
 * the view state + sessionStorage persistence and handles navigation.
 *
 * Props:
 *   view     — current active segment ('list' | 'board')
 *   onChange — callback invoked when user clicks a segment
 *
 * The component is purely presentational: no sessionStorage access, no
 * navigation. All persistence + routing lives in PortalRequestsPage.
 */

export interface BoardToggleProps {
  view: 'list' | 'board';
  onChange: (mode: 'list' | 'board') => void;
}

export function BoardToggle({ view, onChange }: BoardToggleProps) {
  return (
    <div className="flex items-center gap-1 p-1 bg-ms-canvas rounded-lg border border-ms-border">
      <button
        type="button"
        onClick={() => onChange('list')}
        className={
          view === 'list'
            ? 'bg-white border border-ms-border shadow-sm rounded-lg px-3 py-1.5 text-sm font-medium text-ms-text-strong'
            : 'px-3 py-1.5 text-sm text-ms-text-muted hover:text-ms-text rounded-lg'
        }
      >
        <ListBulletIcon className="w-4 h-4 inline mr-1" />
        Requests
      </button>
      <button
        type="button"
        onClick={() => onChange('board')}
        className={
          view === 'board'
            ? 'bg-white border border-ms-border shadow-sm rounded-lg px-3 py-1.5 text-sm font-medium text-ms-text-strong'
            : 'px-3 py-1.5 text-sm text-ms-text-muted hover:text-ms-text rounded-lg'
        }
      >
        <Squares2X2Icon className="w-4 h-4 inline mr-1" />
        Board
      </button>
    </div>
  );
}
